import { AsyncPipe, NgForOf, NgIf, NgStyle, NgSwitch, NgSwitchCase, NgTemplateOutlet } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterOutlet } from '@angular/router';
import { NgxsModule } from '@ngxs/store';
import { BedsState } from '@store/beds/beds.state';
import { EdpState } from '@store/edp/edp.state';
import { HealthState } from '@store/health/health.state';
import { SessionsState } from '@store/sessions/sessions.state';
import { SettingsState } from '@store/settings/settings.state';
import { SleepersState } from '@store/sleepers/sleepers.state';
import { TacoState } from '@store/taco/taco.state';
import { SiqLottieModule } from './lottie.module';
import { ButtonStateDirective } from './utils/directives/button-state.directive';
import { GridDirective } from './utils/directives/grid.directive';
import { InputFormatDirective } from './utils/directives/input-mask.directive';
import { MomentPipe } from './utils/pipes/moment.pipe';
import { TimeConverterPipe } from './utils/pipes/time-converter.pipe';

import { WhyIsThisState } from '@store/why-is-this/why-is-this.state';
import * as CryptoJS from "crypto-js";
import { SetupState } from '@store/setup/setup.state';
import { ScrollableDirective } from './utils/directives/scrollable.directive';

const modules = [
  NgIf, NgTemplateOutlet, NgForOf, AsyncPipe,
  NgSwitch, NgSwitchCase, RouterOutlet,
  ReactiveFormsModule, NgStyle, FormsModule,
];

const directives = [GridDirective, ButtonStateDirective, InputFormatDirective, ScrollableDirective];

const pipes = [TimeConverterPipe, MomentPipe];

@NgModule({
  declarations: [
    ...directives,
    ...pipes
  ],
  imports: [
    ...modules,
    NgxsModule.forFeature([BedsState, SleepersState, SessionsState, SetupState, EdpState, SettingsState, HealthState, TacoState, WhyIsThisState]),
    SiqLottieModule
  ],
  exports: [
    ...directives,
    ...pipes,
    ...modules
  ],
  providers: [
    { provide: 'CryptoJS', useValue: CryptoJS },
    TimeConverterPipe // so it can be injected into SleepHistory Service
  ]
})
export class SiqCommonModule { }